import { gql } from '@apollo/client'

export const GET_MANUFACTURERS = gql`
  query GetManufacturers($searchTerm: String) {
    manufacturers(searchTerm: $searchTerm) {
      name
    }
  }
`
